export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  pageContent: {
    marginLeft: 220,
  },
  tableContainer: {
    padding: "18px",
  },
  headerBarContainer: {
    padding: "8px 30px",
  },
  headerBarTitle: {
    fontSize: 13,
    fontWeight: 600,
  },
});
